// @ts-nocheck
const getQueryParams = (params = {}) => {
  const esc = encodeURIComponent;

  return Object.keys(params)
    .map((k) =>
      Array.isArray(params[k])
        ? params[k].length > 0
          ? `${esc(k)}=${esc(params[k])}`
          : null
        : `${esc(k)}=${esc(params[k])}`,
    )
    .filter(Boolean)
    .join('&');
};

export default getQueryParams;
